var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialogue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#D7DEEA",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3798C6 11.9102 6.21071 12.4189 6.58579 12.794C6.96086 13.1691 7.46957 13.3798 8 13.3798H17L21 15.8734V4.37979C21 3.84936 20.7893 3.34065 20.4142 2.96558C20.0391 2.5905 19.5304 2.37979 19 2.37979H8C7.46957 2.37979 6.96086 2.5905 6.58579 2.96558C6.21071 3.34065 6 3.84936 6 4.37979V11.3798Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2447 17.1266C15.2447 17.6571 15.034 18.1658 14.6589 18.5408C14.2839 18.9159 13.7752 19.1266 13.2447 19.1266H6.22803L2.22803 21.6202V11.1266C2.22803 10.5962 2.43874 10.0875 2.81381 9.7124C3.18889 9.33733 3.69759 9.12662 4.22803 9.12662H5.85693",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.7471,
    y1: 8.12662,
    x2: 16.2526,
    y2: 8.12662,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogue);
export default __webpack_public_path__ + "static/media/dialogue.f3558dd4456172bb16e7e92dca429b76.svg";
export { ForwardRef as ReactComponent };